import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name : 'userSlice',
    initialState : {
        activeUser : '',
        userInfo:JSON.parse(localStorage.getItem("userInfo")|| "{}"),
        fyearInfo:JSON.parse(localStorage.getItem("fyearInfo")|| "{}")
    } ,
    reducers:{
        setActiveUser : (state, action)=>{
          state.activeUser = action.payload;
        },
        SetUserInfo: (state,action)=>{
            state.userInfo = action.payload
        },
        SetWebidInfo: (state,action)=>{
            state.webidInfo = action.payload

        },
        SetFyearInfo: (state,action)=>{
            state.fyearInfo = action.payload
        }
    }
})

export const {setActiveUser,SetUserInfo,SetWebidInfo,SetFyearInfo} = userSlice.actions;
export default userSlice.reducer;